import { AdditionalCustomerInfo } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

const getAdditionalCustomerInfo = async (leaseApplicationId: number): Promise<AdditionalCustomerInfo | undefined> => {
  try {
    const response = await applicationFormService.getAdditionalCustomerInfo(leaseApplicationId);
    return response?.data?.getAdditionalCustomerInfo;
  } catch (err: any) {
    var error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        const forbiddenErrMsg = createForbiddenErrorMessage(err);
        error.forbiddenError = forbiddenErrMsg;
        break;
      case 401:
        const unauthErrMsg = createUnauthorizedErrorMessage(err);
        error.unauthorizedError = unauthErrMsg;
        break;
      default:
        error.errorGeneral = err;
    }
    throw error;
  }
};

export default getAdditionalCustomerInfo;
